function SlideDownElement(element, duration)
{
    element.style.transition = 'height ' + duration + 'ms ease';
    element.style.height = element.scrollHeight + 'px';
}

function SetupSequentialInputs()
{
    var inputContainers = document.querySelectorAll('.trigger-next');
    var marketingTextElement = document.querySelector('.accepts_marketing_text');

    inputContainers.forEach(function(container, index)
    {
        var input = container.querySelector('input');
        if (!input) return;

        input.addEventListener('keyup', function()
        {
            var value = input.value.trim();
            if (value === '') return;

            var nextIndex = index + 1;
            if (nextIndex < inputContainers.length)
            {
                var nextContainer = inputContainers[nextIndex];
                nextContainer.classList.remove('default-hidden');
                SlideDownElement(nextContainer, 300);
            }

            if (index === 1 && marketingTextElement)
            {
                marketingTextElement.classList.remove('default-hidden');
                SlideDownElement(marketingTextElement, 300);
            }
        });
    });
}

function SetupOfferCodeCopy()
{
    var element = document.querySelector('.offer-code');
    if (!element) return;

    element.addEventListener('click', function()
    {
        var text = element.getAttribute('data-copy-text');
        if (!text) return;

        navigator.clipboard.writeText(text).then(function()
        {
            element.classList.add('faded');
            setTimeout(function()
            {
                element.classList.remove('faded');
            }, 900);
        });
    });
}

function IsAnyRegisterPage()
{
    return window.location.pathname == '/account/register';
}

function ApplyQuizFlowFromStorage()
{
    var wrap = document.getElementById( 'lightning-register-wrap' );
    var flow = null;
    var headingEl = null;
    var quizHeading = null;
    var quizButtonText = null;
    var submitButton = null;
    var emailInput = null;

    try { flow = sessionStorage.getItem( 'we_register_flow' ); } catch ( e ) {}
    if ( wrap && flow == 'quiz' )
    {
        wrap.classList.add( 'lightning-register-quiz-flow' );
        wrap.classList.add( 'lightning-register-quiz-fields-collapsed' );
        quizHeading = wrap.getAttribute( 'data-quiz-heading' );
        headingEl = document.querySelector( '.register-heading' );
        if ( quizHeading && headingEl )
        {
            headingEl.textContent = quizHeading;
        }

        quizButtonText = wrap.getAttribute( 'data-quiz-button-text' );
        submitButton = document.querySelector( '.register-submit' );
        if ( quizButtonText && submitButton )
        {
            submitButton.textContent = quizButtonText;
        }

        emailInput = document.querySelector( 'input[name="customer[email]"]' );
        if ( emailInput )
        {
            emailInput.setAttribute( 'placeholder', emailInput.getAttribute( 'placeholder' ) || '' );
        }
    }
}

function SetupQuizFieldReveal()
{
    var wrap = document.getElementById( 'lightning-register-wrap' );
    var emailInput = document.querySelector( 'input[name="customer[email]"]' );

    if ( !wrap || !emailInput || GetRegisterFlow() !== 'quiz' )
    {
        return;
    }

    function updateQuizFieldVisibility()
    {
        if ( emailInput.value.trim() !== '' )
        {
            wrap.classList.remove( 'lightning-register-quiz-fields-collapsed' );
        }
        else
        {
            wrap.classList.add( 'lightning-register-quiz-fields-collapsed' );
        }
    }

    emailInput.addEventListener( 'input', updateQuizFieldVisibility );
    emailInput.addEventListener( 'change', updateQuizFieldVisibility );
    updateQuizFieldVisibility();
}

function SetInputValue( form, name, value )
{
    var input = form.querySelector( 'input[name="' + name + '"]' );

    if ( !input )
    {
        input = document.createElement( 'input' );
        input.type = 'hidden';
        input.name = name;
        form.appendChild( input );
    }
    input.value = value;
}

function GenerateQuizPassword()
{
    return 'WEQuiz' + Date.now() + Math.random().toString( 36 ).slice( 2, 10 ) + '!';
}

function PrepareQuizRegisterForm()
{
}

function IsLoggedInRegister()
{
    var wrap  = document.getElementById( 'lightning-register-wrap' );
    var value = wrap ? wrap.getAttribute( 'data-customer-logged-in' ) : null;

    return ( value == 'true' );
}

function HasRegisterErrors()
{
    return Boolean( document.querySelector( '[data-register-has-errors]' ) );
}

function GetRegisterFlow()
{
    var flow   = null;
    var result = null;

    try { flow = sessionStorage.getItem( 'we_register_flow' ); } catch ( e ) {}
    if ( flow == 'quiz' )
    {
        result = 'quiz';
    }
    else
    {
        var params = new URLSearchParams( window.location.search );
        result = params.get( 'flow' );
    }
    return result;
}

function UpdateRegisterProgressLabelForQuiz()
{
    if ( !IsAnyRegisterPage() )
    {
        return;
    }

    var flow = GetRegisterFlow();
    if ( flow !== 'quiz' )
    {
        return;
    }

    var labels = document.querySelectorAll( '.we-progress__step .we-progress__label' );
    if ( labels.length >= 2 )
    {
        labels[ 1 ].textContent = 'Results';
    }
}

function GetPostRegisterTarget( flow )
{
    var target = '/pages/membership-steps';

    if ( flow == 'cart' )
    {
        target = '/pages/membership-2';
    }
    else if ( flow == 'quiz' )
    {
        target = '/pages/membership-steps?quizsteps=1';
    }
    return target;
}

function SetPostRegisterFlag( flow )
{
    try
    {
        sessionStorage.setItem( 'we_post_register_flow', flow || '' );
        sessionStorage.setItem( 'we_post_register_pending', '1' );
    }
    catch ( e )
    {
    }
}

function ConsumePostRegisterFlag()
{
    var result = null;

    try
    {
        var pending = sessionStorage.getItem( 'we_post_register_pending' );
        if ( pending == '1' )
        {
            result = sessionStorage.getItem( 'we_post_register_flow' ) || '';
            sessionStorage.removeItem( 'we_post_register_pending' );
            sessionStorage.removeItem( 'we_post_register_flow' );
        }
    }
    catch ( e )
    {
    }
    return result;
}

function SetupRegisterSubmitFlag()
{
    var form = null;

    if ( IsAnyRegisterPage() )
    {
        form = document.querySelector( 'form[action^="/account"]' );
    }
    if ( form )
    {
        form.addEventListener( 'submit', RegisterFormSubmitHandler );
    }
}

function RegisterFormSubmitHandler()
{
    var flow     = GetRegisterFlow();
    var form     = document.querySelector( 'form[action^="/account"]' );
    var tagInput = null;

    SetPostRegisterFlag( flow );
    if ( flow == 'quiz' && form )
    {
        tagInput = form.querySelector( 'input[name="customer[tags]"]' );
        if ( !tagInput )
        {
            tagInput = document.createElement( 'input' );
            tagInput.type  = 'hidden';
            tagInput.name  = 'customer[tags]';
            form.appendChild( tagInput );
        }
        tagInput.value = 'quiz_taken';
    }
}

function CustomerHasQuizTaken()
{
    const wrap  = document.getElementById( 'lightning-register-wrap' );
    const value = wrap ? wrap.getAttribute( 'data-customer-quiz-taken' ) : null;
    return ( value == 'true' );
}

function HandleRegisterRedirect()
{
    var target = null;

    if ( IsAnyRegisterPage() && !HasRegisterErrors() && IsLoggedInRegister() )
    {
        var pendingFlow = ConsumePostRegisterFlag();
        if ( pendingFlow != null )
        {
            target = GetPostRegisterTarget( pendingFlow );
        }
        else
        {
            if ( CustomerHasQuizTaken() )
            {
                target = '/pages/welleasy-quiz?slide=15';
            }
            else
            {
                target = '/pages/lightning-my-aisle';
            }
        }
    }
    if ( target != null )
    {
        window.location.replace( target );
    }
}

function LightningRegisterInit()
{
    SetupQuizFieldReveal();
    SetupRegisterSubmitFlag();
}

function IsMembershipPage()
{
    var p = window.location.pathname;
    return (p === '/pages/membership-steps' || p === '/pages/membership-2');
}

function ReloadMembershipIfBackNav(event)
{
    if ( event && event.persisted === true && IsMembershipPage() )
    {
        window.location.reload();
    }
}

function initMembershipRedesignCta()
{
    var wrapper       = document.querySelector(".membership-wrapper[data-membership-variant-id], .membership-wrapper-redesigned[data-membership-variant-id]");
    var cta           = wrapper && wrapper.querySelector(".js-membership-redesign-cta");
    var variantId     = wrapper ? wrapper.getAttribute("data-membership-variant-id") : "";
    var sellingPlanId = wrapper ? (wrapper.getAttribute("data-membership-selling-plan-id") || "") : "";
    var redirectUrl   = cta ? (cta.getAttribute("href") || "/checkout") : "";
    var canProceed    = cta && wrapper && variantId;

    if (canProceed)
    {
        function handleCtaClick(e)
        {
            e.preventDefault();

            if (!cta.classList.contains("loading"))
            {
                cta.classList.add("loading");
                cta.style.pointerEvents = "none";
                if ( redirectUrl.indexOf( "welleasy-quiz" ) >= 0 )
                {
                    try { localStorage.removeItem( "skip_to_membership_page" ); } catch ( err ) { }
                }

                function redirectToCheckout()
                {
                    if ( redirectUrl.indexOf( "welleasy-quiz" ) >= 0 )
                    {
                        try { localStorage.removeItem( "skip_to_membership_page" ); } catch ( err ) { }
                        try { sessionStorage.setItem( "cta_quiz_destination", "1" ); } catch ( err ) { }
                        try { sessionStorage.setItem( "cta_quiz_show_results", "1" ); } catch ( err ) { }
                    }
                    window.location.href = redirectUrl;
                }

                function parseCartResponse(response)
                {
                    return response.json();
                }

                function checkCartAndAddItem(cart)
                {
                    function isMatchingVariant(item)
                    {
                        return String(item.variant_id) == String(variantId);
                    }

                    var inCart  = WE_CartHasMembership( cart ) || ( cart.items && cart.items.some( isMatchingVariant ) );
                    var body    = { items: [ { quantity: 1, id: parseInt(variantId, 10) } ] };
                    var promise = null;

                    if (inCart)
                    {
                        redirectToCheckout();
                    }
                    else
                    {
                        if (sellingPlanId)
                        {
                            body.items[0].selling_plan = parseInt(sellingPlanId, 10);
                        }
                        promise = fetch("/cart/add.js",
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json", "Accept": "application/json" },
                            body: JSON.stringify(body)
                        }).then(handleAddToCartResponse);
                    }

                    return promise;
                }

                function handleAddToCartResponse(response)
                {
                    if (response.ok)
                    {
                        redirectToCheckout();
                    }
                    else
                    {
                        response.json().then(handleAddToCartError);
                    }
                }

                function handleAddToCartError(err)
                {
                    console.error(err);
                    redirectToCheckout();
                }

                function handleFetchError()
                {
                    redirectToCheckout();
                }

                fetch("/cart.js")
                    .then(parseCartResponse)
                    .then(checkCartAndAddItem)
                    .catch(handleFetchError);
            }
        }

        cta.addEventListener("click", handleCtaClick);
    }
}

// NUCLEAR OPTION: Force reload register page on any bfcache restore
window.addEventListener( 'pageshow', function( event )
{
    if ( event.persisted && IsAnyRegisterPage() )
    {
        window.location.reload();
    }
    ReloadMembershipIfBackNav( event );
    HandleRegisterRedirect();
} );

function LightningRegisterDomReady()
{
    SetupSequentialInputs();
    SetupOfferCodeCopy();
    initMembershipRedesignCta();
}

document.addEventListener( "DOMContentLoaded", function()
{
    UpdateRegisterProgressLabelForQuiz();
    ApplyQuizFlowFromStorage();
    if ( IsAnyRegisterPage() && GetRegisterFlow() === "quiz" && typeof WE_QuizTracking_Push === "function" )
    {
        WE_QuizTracking_Push( "quiz_register_view", { registration_flow: "quiz" } );
    }
    LightningRegisterInit();
    HandleRegisterRedirect();
    LightningRegisterDomReady();
} );
